import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ChakraProvider as Theme } from '@chakra-ui/react';
import ScrollToTop from '../commons/ScrollToTop';

import SkillsRoute from '../../presentation/pages/Skills';
import SkillRoute from '../../presentation/pages/Skill';

const Root = () =>
(
    <Router history={ createBrowserHistory() }>
    <Theme>
        <ScrollToTop />
        <Switch>
            <Route path="/:skill" component={ SkillRoute } />
            <Route path="/" component={ SkillsRoute } />
        </Switch>
    </Theme>
    </Router>
);

export default Root;